<template>

<app-wrapper :fill="!suppliers.length" :loading="is.loading">

	<app-empty v-if="!suppliers.length">{{ page.business_suppliers_empty }}</app-empty>

    <div class="suppliers-item" v-for="(supplier, index) in suppliers" :key="index">

        <div class="suppliers-item-image" :style="{backgroundImage: 'url(' + supplier.image + ')'}"></div>

        <div class="suppliers-item-text">

            <div class="suppliers-item-text-name">{{ supplier.name }}</div>
            <div class="suppliers-item-text-description">{{ supplier.text }}</div>

            <div class="suppliers-text-status" v-if="supplier.status">{{ supplier.status }}</div>

            <div class="suppliers-item-text-contact">

                <div class="suppliers-item-text-contact-item">
                    
                    <app-icon name="location" /> 
                    <div class="suppliers-item-text-contact-item-text"><a :href="linkAddress(supplier.address)">{{ supplier.address }}</a></div>
                    
                </div>

                <div class="suppliers-item-text-contact-item">
                    
                    <app-icon name="phone" /> 
                    <div class="suppliers-item-text-contact-item-text"><a :href="linkPhone(supplier.phone)">{{ supplier.phone }}</a></div>

                </div>

            </div>

            <div class="suppliers-item-text-actions" v-if="supplier.website">
                
                <app-button :href="supplier.website" target="_blank" theme="blue" :text="page.business_suppliers_visit" :arrow="true" />
                
            </div>

        </div>

    </div>

    <app-pagination :pages="pages" :current="current" v-on:change="onPageChange" />

</app-wrapper>

</template>

<script>

export default {

    data: function() {

        return {
            is: {
                loading: false
            },
            suppliers: [],
            pages: 1,
            current: 1,
            total: 0
        }

    },

    created: function() {
      
        this.fetch()
        
    },

    methods: {

        linkAddress: function(address) {

            return 'https://www.google.co.uk/maps/search/' + encodeURIComponent(address)
             
        },

        linkPhone: function(phone) {

            return 'tel:' + phone.replace(' ', '')

        },

        onPageChange: function(value) {

            this.current = value
            this.fetch()

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('account/suppliers', {
                page: this.current
            }).then(function(json) {

                this.suppliers = json.items
                this.pages = json.pages
                this.current = json.page 
                this.total = json.total

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.suppliers-item {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 20px;
    transition: all 100ms linear;
    display: flex;
    flex-direction: row;
}

.is-mobile .suppliers-item {
    padding: 10px;
	flex-direction: column;
	align-items: center;
}

.is-desktop .suppliers-item:hover {
    border-color: var(--color-grey-highlight);
}

.suppliers-item-image {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    flex-shrink: 0;
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px;
}

.is-mobile .suppliers-item-image {
    width: 120px;
    height: 120px;
	margin-bottom: 10px;
	margin-right: 0px;
}

.suppliers-item-text {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.is-mobile .suppliers-item-text {
	flex-grow: 0;
	width: 100%;
}

.suppliers-item-text-name {
	font-size: 20px;
	font-family: "grueber",serif;
	color: var(--color-grey-dark);
	margin-bottom: 2px;
}

.is-mobile .suppliers-item-text-name {
	text-align: center;
}

.suppliers-item-text-description {
	font-size: 14px;
	line-height: 20px;
	font-weight: 300;
	color: var(--color-grey-dark);
	flex-grow: 1;
	flex-basis: 0;
}

.is-mobile .suppliers-item-text-description {
	text-align: center;
}

.suppliers-item-text-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.suppliers-text-status {
	background-color: var(--color-grey-light);
	color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
	padding: 10px;
	border-radius: 4px;
	margin-top: 12px;
	width: 100%;
}

.suppliers-text-status:before {
    content: ' ';
    position: absolute;
    left: 20px;
    top: -8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent var(--color-grey-light) transparent;
}

.is-mobile .suppliers-text-status {
	text-align: center;
}

.is-mobile .suppliers-text-status:before {
	left: 50%;
	margin-left: -4px;
}

.suppliers-item-text-contact {
    background-color: var(--color-grey-lightest);
    border-radius: 4px;
    padding: 20px 20px 15px 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
	margin-top: 20px;
}

.is-mobile .suppliers-item-text-contact {
    padding: 10px;
}

.suppliers-item-text-contact-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}

.suppliers-item-text-contact-item:last-child {
    margin-bottom: 0px;
}

.suppliers-item-text-contact-item >>> .icon {
    width: 24px;
    line-height: 32px;
    text-align: center;
    height: 32px;
    flex-shrink: 0;
    font-size: 20px;
    color: var(--color-blue-light);
}

.suppliers-item-text-contact-item-text {
    padding-left: 15px;
    flex-grow: 1;
    color: var(--color-grey-dark);
}

.suppliers-item-text-contact-item-text a {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
}

.is-desktop .suppliers-item-text-contact-item-text a:hover {
    text-decoration: underline;
}

.suppliers-item-text-contact-item-text small {
    font-size: 11px;
    margin-top: 2px;
    display: block;
}

</style>